import styled, { css } from "styled-components";
import { breakpoints, focusedState } from "root/libs/ui-styleguide/src";

export const StyledQuantityField = styled.div`
  /* Number input fields should not change order of buttons */
  /* We force ltr here and add the noflip rule to maintain fixed... */
  /*! @noflip */
  direction: ltr;
  ${(props) =>
    props.marginBottom ? `margin-bottom: ${props.marginBottom};` : ""};
`;

export const StyledButtonWrapper = styled.div`
  position: relative;
`;

export const StyledWrapper = styled.div`
  /* ...but here we define direction again without noflip rule so it gets mirrored */
  direction: ltr;
  border: var(--dui-size-width-border-xs) solid var(--dui-color-gray-500);
  position: relative;
  border-radius: var(--dui-size-radius-md);
  display: flex;
  flex-direction: column;
  background-color: var(--dui-color-white-500);
  padding: var(--dui-size-space-6x) var(--gaq-size-space-30px)
    var(--dui-size-space-5x) var(--gaq-size-space-30px);
  ${focusedState.focusWithinAllBorders};

  &:hover {
    border-color: var(--dui-color-black-500);
  }

  &:focus-within {
    box-shadow: var(--dui-size-space-0) var(--dui-size-space-0)
      var(--dui-size-space-0) var(--dui-size-space-1) var(--dui-color-black-500);
  }

  label {
    order: 1;
    padding-top: var(--dui-size-space-5x);
    padding-bottom: var(--dui-size-space-2x);
    line-height: 1;
  }

  .dhl-cj-main & {
    line-height: 17px;
  }

  input {
    line-height: 17px;
    height: auto !important;
    order: 2;
    padding: var(--gaq-size-space-5px) var(--dui-size-space-5x)
      var(--gaq-size-space-5px) var(--dui-size-space-5x) !important;
    border-color: transparent;
    width: ${(props) => (props.preventTextAndIconOverlap ? "90%" : "100%")};
    text-overflow: ellipsis;
    text-align: center;
    font-weight: bold;

    &:hover,
    &:focus {
      border-color: transparent !important;
      box-shadow: none !important;
    }
  }

  @supports (display: grid) {
    grid-column: 1 / span 2;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    @supports (display: grid) {
      grid-column: unset;
    }
  }
`;

export const numberButton = css`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 1px;
  width: 40px;
  height: 100%;
  line-height: 54px;
  font-size: var(--dui-size-font-4xl);
  background-color: transparent;
  text-align: center;
  cursor: pointer;
  user-select: none;
  padding: 0;
  border: var(--dui-size-width-border-xs) solid transparent;
  z-index: 1;
  outline: 1px solid transparent;
  border-color: transparent;
  box-sizing: border-box;
  ${focusedState.focusAllBorders};
`;

export const StyledMinusButton = styled.button`
  ${numberButton}
  left: 1px;
  margin: var(--gaq-size-space--1px) 0 var(--gaq-size-space--1px)
    var(--gaq-size-space--1px);
  border-radius: var(--dui-size-radius-md) 0 0 var(--dui-size-radius-md);
`;

export const StyledPlusButton = styled.button`
  ${numberButton}
  border-radius: 0 var(--dui-size-radius-md) var(--dui-size-radius-md) 0;
  margin: var(--gaq-size-space--1px) var(--gaq-size-space--1px)
    var(--gaq-size-space--1px) 0;
  right: 1px;
`;
